import { useState, forwardRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { InputGroup, Input, InputGroupText, Label } from "reactstrap";

const InputPasswordToggle = forwardRef((props, ref) => {
    
    // ** Props
    const {
        label,
        hideIcon = false,
        showIcon = false,
        visible = false,
        className,
        htmlFor,
        placeholder,
        iconSize,
        invalid = false,
        required = false,
        name,
        value = "",
        ...rest
    } = props;

    // ** State
    const [inputVisibility, setInputVisibility] = useState(visible);

    // ** Renders Icon Based On Visibility
    const renderIcon = () => {
        const size = iconSize ? iconSize : 14;

        if (inputVisibility === false) {
            return hideIcon ? (
                hideIcon
            ) : (
                <i className="mdi mdi-eye-off-outline" size={size} data-cy="hide-icon" />
            );
        } else {
            return showIcon ? (
                showIcon
            ) : (
                <i className="mdi mdi-eye-outline" size={size} data-cy="show-icon" />
            );
        }
    };

    return (
        <>
            {label && (
                <Label htmlFor={name}>
                    {label}
                    {required && (
                        <span className="text-danger fw-bolder">*</span>
                    )}
                </Label>
            )}
            <InputGroup
                className={classnames({
                    [className] : className,
                    "is-invalid": invalid
                })}>
                <Input
                    ref={ref}
                    invalid={invalid}
                    value={value || ""}
                    max={255}
                    autoComplete="new-password"
                    type={inputVisibility === false ? "password" : "text"}
                    placeholder={placeholder ? placeholder : "············"}
                    data-cy={`input-${name}`}
                    className={classnames(
                        "password-border-radius"
                    )}
                    /*eslint-disable */
                    {...(label && htmlFor
                        ? {
                              id: htmlFor,
                          }
                        : {})}
                    {...rest}
                />
                <InputGroupText
                    className="cursor-pointer"
                    onClick={() => setInputVisibility(!inputVisibility)}>
                    {renderIcon()}
                </InputGroupText>
            </InputGroup>
        </>
    );
});

export default InputPasswordToggle;

// ** PropTypes
InputPasswordToggle.propTypes = {
    invalid: PropTypes.bool,
    hideIcon: PropTypes.node,
    showIcon: PropTypes.node,
    visible: PropTypes.bool,
    value: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    iconSize: PropTypes.number,
    label(props, propName) {
        // ** If label is defined and htmlFor is undefined throw error
        if (props[propName] && props["htmlFor"] === "undefined") {
            throw new Error(
                "htmlFor prop is required when label prop is present"
            );
        }
    },
    htmlFor(props, propName) {
        // ** If htmlFor is defined and label is undefined throw error
        if (props[propName] && props["label"] === "undefined") {
            throw new Error(
                "label prop is required when htmlFor prop is present"
            );
        }
    },
    required: PropTypes.bool,
};

